module.exports = __webpack_public_path__ + "static/media/login-bg.36e8b341.jpg";